/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionleader3Inputs */



/**
* | output |
* | --- |
* | "You’re the one who can take charge. You like structuring chaos, bringing everyone together, and being the person who actually knows where you’re all going an..." |
*
* @param {Personalityarchetypedescriptionleader3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionleader3 = /** @type {((inputs?: Personalityarchetypedescriptionleader3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionleader3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You’re the one who can take charge. You like structuring chaos, bringing everyone together, and being the person who actually knows where you’re all going and what time the table’s booked.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eres quien sabe tomar el mando. Te gusta estructurar el caos, reunir a todos y ser la persona que realmente sabe a dónde van y a qué hora es la reserva.")
	return /** @type {LocalizedString} */ ("Ты умеешь брать ответственность. Тебе нравится структурировать хаос, собирать всех вместе и быть тем, кто точно знает, куда вы идете и во сколько бронь столика.")
});
export { personalityarchetypedescriptionleader3 as "personalityArchetypeDescriptionLeader" }